import { docSource, docViewerKind } from './doc-viewer';

/**
 * The URL a PDF thumbnail embeds, or null when this file is not a PDF we can point a viewer at.
 *
 * A PDF's body is a pointer, never stored text, so only the `remote` load plan can produce a preview —
 * an inline body means the content was something we could not read. Pure, so the rule is testable without
 * rendering an embed.
 */
export function pdfPreviewUrl(name: string | undefined, content: string | undefined, contentType?: string): string | null {
  if (docViewerKind(name, content, contentType) !== 'pdf') return null;
  if (!content) return null;
  const source = docSource(content);
  return source?.kind === 'remote' ? source.url : null;
}
